import React from 'react';
import './FallingCoinRolls.css';

const COIN_ROLL_IMAGES = [
  '/coin-roll-sprites/cr-1c.png',
  '/coin-roll-sprites/cr-2c.png',
  '/coin-roll-sprites/cr-5c.png',
  '/coin-roll-sprites/cr-10c.png',
  '/coin-roll-sprites/cr-20c.png',
  '/coin-roll-sprites/cr-50c.png',
  '/coin-roll-sprites/cr-1e.png',
  '/coin-roll-sprites/cr-2e.png',
];

const UNIFORM_ROLL_WIDTH = 200;
const TOTAL_ROLLS = 7;

function lerp(min: number, max: number, t: number): number {
  return min + (max - min) * t;
}

function randomRange(min: number, max: number): number {
  return lerp(min, max, Math.random());
}

interface RollItemConfig {
  id: number;
  left: number; // percentage 0-100 across screen
  duration: number; // seconds
  delay: number; // negative seconds for immediate random vertical scatter on load
  startRotation: number; // degrees
  endRotation: number; // degrees
  opacity: number;
  imageSrc: string;
}

// Generate the initial scattered coin rolls configuration once
const INITIAL_ROLLS: RollItemConfig[] = (() => {
  const items: RollItemConfig[] = [];

  for (let i = 0; i < TOTAL_ROLLS; i++) {
    const left = randomRange(3, 93);
    const duration = randomRange(24, 34);
    // Negative delay between 0 and full duration scatters rolls randomly across the entire viewport on load
    const delay = -randomRange(0, duration);
    const baseAngle = randomRange(-45, 45);
    const spinDelta = (Math.random() < 0.5 ? 1 : -1) * randomRange(20, 45);
    const startRotation = Math.max(-80, Math.min(80, baseAngle));
    const endRotation = Math.max(-80, Math.min(80, baseAngle + spinDelta));
    const opacity = randomRange(0.18, 0.26);
    const imageSrc = COIN_ROLL_IMAGES[i % COIN_ROLL_IMAGES.length];

    items.push({
      id: i,
      left,
      duration,
      delay,
      startRotation,
      endRotation,
      opacity,
      imageSrc,
    });
  }

  return items;
})();

export const FallingCoinRolls: React.FC = React.memo(() => {
  return (
    <div className="falling-coin-rolls-layer" aria-hidden="true">
      {INITIAL_ROLLS.map((r) => (
        <div
          key={r.id}
          className="falling-coin-roll-wrapper"
          style={{
            left: `${r.left}%`,
            width: `${UNIFORM_ROLL_WIDTH}px`,
            animationDuration: `${r.duration}s`,
            animationDelay: `${r.delay}s`,
            opacity: r.opacity,
            '--start-rot': `${r.startRotation}deg`,
            '--end-rot': `${r.endRotation}deg`,
          } as React.CSSProperties}
        >
          <img
            src={r.imageSrc}
            alt=""
            className="falling-coin-roll-img"
            draggable={false}
          />
        </div>
      ))}
    </div>
  );
});

FallingCoinRolls.displayName = 'FallingCoinRolls';
